import { I18n } from "@assets/strings";
import React from "react";
import styled, { css } from "styled-components";
import { ReportDraft } from "@domain/report/report";
import { useModalTools } from "@ui/modals/modalContext";
import { ReportModal } from "@ui/modals/reportModal";
import { theme } from "@ui/styles/theme";
import { gap } from "@ui/styles/utils";
import { DeleteIconBlack, EditIcon, ErrorIcon, FavoriteOffIcon, RepostIcon } from "@ui/components/icons";
import { row } from "@ui/components/layout";
import { MenuRow } from "./menuRow";

interface SimpleMenuContentProps extends React.HTMLAttributes<HTMLDivElement> {
	onEdit?: () => void;
	editLabel?: string;
	onDelete?: () => void;
	onFavorite?: () => void;
	favorite?: boolean;
	onShare?: () => void;
	reportInfos?: Omit<ReportDraft, "motive">;
	disinterest?: () => void;
}
export const SimpleMenuContent: React.FC<SimpleMenuContentProps> = ({
	onEdit,
	editLabel,
	onDelete,
	reportInfos,
	children,
	onShare,
	onFavorite,
	favorite,
	disinterest,
	...htmlProps
}) => {
	const { createModal } = useModalTools();

	return (
		<Container {...htmlProps}>
			{children}
			{!!onFavorite && (
				<MenuRow onClick={onFavorite}>
					<IconWrapper>
						<FavoriteOffIcon toggled={favorite} />
					</IconWrapper>
					<span>{editLabel ?? I18n.t("favorite")}</span>
				</MenuRow>
			)}
			{onShare && (
				<MenuRow onClick={onShare}>
					<IconWrapper>
						<RepostIcon />
					</IconWrapper>
					<span>{editLabel ?? I18n.t("share")}</span>
				</MenuRow>
			)}
			{!!onEdit && (
				<MenuRow onClick={onEdit}>
					<IconWrapper>
						<EditIcon />
					</IconWrapper>
					<span>{editLabel ?? I18n.t("edit")}</span>
				</MenuRow>
			)}

			{!!onDelete && (
				<MenuRow onClick={onDelete}>
					<IconWrapper>
						<DeleteIconBlack />
					</IconWrapper>
					<span>{I18n.t("delete")}</span>
				</MenuRow>
			)}
			{reportInfos && (
				<MenuRow onClick={() => createModal((close) => <ReportModal reportInfos={reportInfos} close={close} />)}>
					<IconWrapper primaryColor>
						<ErrorIcon />
					</IconWrapper>
					<span>{I18n.t("report.action")}</span>
				</MenuRow>
			)}
			{!!disinterest && (
				<MenuRow onClick={disinterest}>
					<IconWrapper primaryColor>
						<DeleteIconBlack color={theme.colors.primary} />
					</IconWrapper>
					<span>{I18n.t("uninterest")}</span>
				</MenuRow>
			)}
		</Container>
	);
};

const Container = styled.div`
	${gap(20)};
`;

export const IconWrapper = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "primaryColor",
})<{ primaryColor?: boolean }>`
	flex-shrink: 0;
	border-radius: 9px;
	width: 34px;
	height: 34px;
	background-color: ${({ theme, primaryColor }) =>
		primaryColor ? theme.colors.primaryLight : theme.colors.secondaryLight};
	${row(0, "center", "center")};
	${({ primaryColor }) =>
		primaryColor
			? css`
					> svg .main-path {
						fill: ${({ theme }) => theme.colors.primary};
					}
				`
			: css`
					> svg path {
						fill: ${({ theme }) => theme.colors.secondary};
					}
				`};
`;
